import React from 'react';
import { Alert } from 'antd';
import { WifiOutlined, LoadingOutlined, DisconnectOutlined } from '@ant-design/icons';
import { useWebSocket } from '../../contexts/WebSocketContext';

/**
 * Connection status indicator for WebSocket.
 * Only shows when disconnected or reconnecting.
 */
const ConnectionStatus = () => {
  const { connectionState } = useWebSocket();

  // Don't show anything when connected
  if (connectionState === 'CONNECTED' || connectionState === 'CONNECTING') {
    return null;
  }

  if (connectionState === 'RECONNECTING') {
    return (
      <Alert
        type="warning"
        showIcon
        icon={<LoadingOutlined spin />}
        message="Възстановяване на връзката..."
        style={{ marginBottom: 16 }}
      />
    );
  }

  if (connectionState === 'DISCONNECTED') {
    return (
      <Alert
        type="error"
        showIcon
        icon={<DisconnectOutlined />}
        message="Връзката е прекъсната. Моля, опреснете страницата."
        style={{ marginBottom: 16 }}
      />
    );
  }

  return null;
};

export default ConnectionStatus;
